import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";

import useDefaultCustomDomain from "./useDefaultCustomDomain";

const usePublishedSiteUrls = ({
  pageRoutesToUseForPreview,
}: {
  pageRoutesToUseForPreview: string[];
}) => {
  const { project } = useCurrentProjectContext();

  const defaultCustomDomain = useDefaultCustomDomain();

  // NOTE (Cole, 2025-07-14): This should never result in undefined for a published site
  const reploShopsUrls = pageRoutesToUseForPreview.map((pageRoute) => {
    return project?.shopDomainPrefix
      ? `https://${project.shopDomainPrefix}.reploshops.com${pageRoute}`
      : undefined;
  });

  const publishedSiteUrls = pageRoutesToUseForPreview.map(
    (pageRoute, index) => {
      return defaultCustomDomain?.value
        ? `https://${defaultCustomDomain.value}${pageRoute}`
        : reploShopsUrls[index];
    },
  );

  return publishedSiteUrls;
};

export default usePublishedSiteUrls;
